import { render, staticRenderFns } from "./tcc-icon.vue?vue&type=template&id=748fe53c"
import script from "./tcc-icon.vue?vue&type=script&lang=js"
export * from "./tcc-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports